import { Config } from "../../../../Config";
import { LayaGL } from "../../../layagl/LayaGL";
import { FastSinglelist } from "../../../utils/SingletonList";
import { WebDefineDatas } from "../../RenderModuleData/WebModuleData/WebDefineDatas";
import { WebGLEngine } from "../RenderDevice/WebGLEngine";
export class WebGLRenderElement3D {
    constructor() {
        this._shaderInstances = new FastSinglelist();
    }
    _addShaderInstance(shader) {
        this._shaderInstances.add(shader);
    }
    _clearShaderInstance() {
        this._shaderInstances.length = 0;
    }
    _preUpdatePre(context) {
        this._compileShader(context);
        if (this.materialShaderData && Config.matUseUBO) {
            let subShader = this.subShader;
            let materialData = this.materialShaderData;
            let matSubBuffer = materialData.createSubUniformBuffer("Material", subShader._owner.name, subShader._uniformMap);
            if (matSubBuffer) {
                matSubBuffer.upload();
            }
        }
        if (this.owner && Config._uniformBlock) {
            for (let [key, value] of this.owner.additionShaderData) {
                let shaderData = value;
                let unifomrMap = LayaGL.renderDeviceFactory.createGlobalUniformMap(key);
                let uniformBuffer = shaderData.createSubUniformBuffer(key, key, unifomrMap._idata);
                if (uniformBuffer) {
                    uniformBuffer.upload();
                }
            }
        }
        this._invertFront = this._getInvertFront();
    }
    _getInvertFront() {
        var _a;
        let transform = (_a = this.owner) === null || _a === void 0 ? void 0 : _a.transform;
        return transform ? transform._isFrontFaceInvert : false;
    }
    _render(context) {
        let forceInvertFace = context.invertY;
        let updateMark = context.cameraUpdateMask;
        let sceneShaderData = context.sceneData;
        let cameraShaderData = context.cameraData;
        if (this.isRender) {
            let passes = this._shaderInstances.elements;
            for (let j = 0, m = this._shaderInstances.length; j < m; j++) {
                const shaderIns = passes[j];
                if (!shaderIns.complete)
                    continue;
                let switchShader = shaderIns.bind();
                let switchUpdateMark = (updateMark !== shaderIns._uploadMark);
                let uploadScene = (shaderIns._uploadScene !== sceneShaderData) || switchUpdateMark;
                if (uploadScene || switchShader) {
                    if (sceneShaderData) {
                        shaderIns.uploadUniforms(shaderIns._sceneUniformParamsMap, sceneShaderData, uploadScene);
                    }
                    shaderIns._uploadScene = sceneShaderData;
                }
                if (this.renderShaderData) {
                    let uploadSprite3D = (shaderIns._uploadRender !== this.renderShaderData) || switchUpdateMark;
                    if (uploadSprite3D || switchShader) {
                        shaderIns.uploadUniforms(shaderIns._spriteUniformParamsMap, this.renderShaderData, uploadSprite3D);
                        shaderIns._uploadRender = this.renderShaderData;
                    }
                }
                if (this.owner) {
                    let additionShaderData = this.owner.additionShaderData;
                    for (let [key, encoder] of shaderIns._additionUniformParamsMaps) {
                        let additionData = additionShaderData.get(key);
                        if (additionData) {
                            let needUpload = shaderIns._additionShaderData.get(key) !== additionData || switchUpdateMark;
                            if (needUpload || switchShader) {
                                shaderIns.uploadUniforms(encoder, additionData, needUpload);
                                shaderIns._additionShaderData.set(key, additionData);
                            }
                        }
                    }
                }
                let uploadCamera = shaderIns._uploadCameraShaderValue !== cameraShaderData || switchUpdateMark;
                if (uploadCamera || switchShader) {
                    cameraShaderData && shaderIns.uploadUniforms(shaderIns._cameraUniformParamsMap, cameraShaderData, uploadCamera);
                    shaderIns._uploadCameraShaderValue = cameraShaderData;
                }
                let uploadMaterial = (shaderIns._uploadMaterial !== this.materialShaderData) || switchUpdateMark;
                if (uploadMaterial || switchShader) {
                    shaderIns.uploadUniforms(shaderIns._materialUniformParamsMap, this.materialShaderData, uploadMaterial);
                    shaderIns._uploadMaterial = this.materialShaderData;
                }
                shaderIns.uploadRenderStateBlendDepth(this.materialShaderData);
                shaderIns.uploadRenderStateFrontFace(this.materialShaderData, forceInvertFace, this._invertFront);
                this.drawGeometry(shaderIns);
            }
        }
    }
    _getShaderInstanceDefines(context) {
        let comDef = WebGLRenderElement3D._compileDefine;
        const globalShaderDefines = context._getContextShaderDefines();
        globalShaderDefines.cloneTo(comDef);
        if (this.renderShaderData) {
            comDef.addDefineDatas(this.renderShaderData.getDefineData());
        }
        if (this.materialShaderData) {
            comDef.addDefineDatas(this.materialShaderData._defineDatas);
        }
        if (this.owner) {
            let additionShaderData = this.owner.additionShaderData;
            if (additionShaderData.size > 0) {
                for (let [key, value] of additionShaderData.entries()) {
                    comDef.addDefineDatas(value.getDefineData());
                }
            }
        }
        return comDef;
    }
    _compileShader(context) {
        this._clearShaderInstance();
        let comDef = this._getShaderInstanceDefines(context);
        var passes = this.subShader._passes;
        for (var j = 0, m = passes.length; j < m; j++) {
            let pass = passes[j];
            let passdata = pass.moduleData;
            if (passdata.pipelineMode !== context.pipelineMode)
                continue;
            if (this.renderShaderData) {
                passdata.nodeCommonMap = this.owner._commonUniformMap;
            }
            else {
                passdata.nodeCommonMap = null;
            }
            passdata.additionShaderData = null;
            if (this.owner) {
                passdata.additionShaderData = this.owner._additionShaderDataKeys;
            }
            var shaderIns = pass.withCompile(comDef);
            this._addShaderInstance(shaderIns);
        }
    }
    drawGeometry(shaderIns) {
        WebGLEngine.instance.getDrawContext().drawGeometryElement(this.geometry);
    }
    destroy() {
        this.geometry = null;
        this._shaderInstances = null;
        this.materialShaderData = null;
        this.renderShaderData = null;
        this.transform = null;
        this.isRender = null;
    }
}
WebGLRenderElement3D._compileDefine = new WebDefineDatas();
